import { Card, CardContent, TextField, Grid, Button, Checkbox, FormControlLabel } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { useEffect } from "react";
import {
  useGetMembershipsQuery,
  useUpdateMembershipMutation,
  useAddMembershipMutation
} from "../../../../Services/SupplierService";
import { MembershipFormInputs } from "../../../../Helpers/Interfaces/SupplierType";

interface MemberProps {
  open: boolean;
  onClose: () => void;
  updateData?: MembershipFormInputs;
}



const AddMembership = ({ open, onClose, updateData }: MemberProps) => {
  const [updateMembership] = useUpdateMembershipMutation();
  const [addMembership] = useAddMembershipMutation();

  const {
    control,
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm<MembershipFormInputs>({
    defaultValues: { supplierLevel: "", description: "", value: 0, isActive: false },
  });

  useEffect(() => {
    if (updateData) {
      setValue("supplierLevel", updateData.supplierLevel || "");
      setValue("description", updateData.description || "");
      setValue("value", updateData.value || 0);
      setValue("isActive", updateData.isActive || false);
    }
  }, [updateData, setValue]);

  const onSubmit = async (data: MembershipFormInputs) => {
    try {
      if (updateData && updateData?._id) {
        await updateMembership({ _id: updateData?._id, data:data });
      } else {
        await addMembership(data);
      }
      onClose();
    } catch (error) {
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Controller
                name="supplierLevel"
                control={control}
                rules={{ required: "Supplier Level is required" }}
                render={({ field }) => (
                  <TextField
                    sx={{ mb: 2 }}
                    fullWidth
                    label="Supplier Level"
                    {...field}
                    error={!!errors.supplierLevel}
                    helperText={errors.supplierLevel?.message}
                  />
                )}
              />
              <Controller
                name="description"
                control={control}
                rules={{ required: "Description is required" }}
                render={({ field }) => (
                  <TextField
                    sx={{ mb: 2 }}
                    fullWidth
                    label="Description"
                    {...field}
                    error={!!errors.description}
                    helperText={errors.description?.message}
                  />
                )}
              />
              <Controller
                name="value"
                control={control}
                rules={{
                  required: "Value is required",
                  min: { value: 0, message: "Value must be greater than and equal to zero" },
                }}
                render={({ field }) => (
                  <TextField
                    sx={{ mb: 2 }}
                    fullWidth
                    type="number"
                    label="Value"
                    {...field}
                    error={!!errors.value}
                    helperText={errors.value?.message}
                  />
                )}
              />
              <Controller
                name="isActive"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    control={<Checkbox {...field} checked={field.value} />}
                    label="Is-active?"
                  />
                )}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Button type="submit" variant="contained" color="primary" sx={{ ml: 2 }}>
        Save Changes
      </Button>
    </form>
  );
};

export default AddMembership;